import { render, staticRenderFns } from "./GraphDetail01.vue?vue&type=template&id=3960728c&scoped=true"
import script from "./GraphDetail01.vue?vue&type=script&lang=js"
export * from "./GraphDetail01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960728c",
  null
  
)

export default component.exports